import { render, staticRenderFns } from "./ExternalImageThumbnail.vue?vue&type=template&id=397fc81a&scoped=true&"
import script from "./ExternalImageThumbnail.vue?vue&type=script&lang=ts&"
export * from "./ExternalImageThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalImageThumbnail.vue?vue&type=style&index=0&id=397fc81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397fc81a",
  null
  
)

export default component.exports